module.exports = __webpack_public_path__ + "static/media/all-college-adminsion-bg.d78f16ac.jpg";